var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExtraHoliday(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 185.7 200",
    style: {
      enableBackground: "new 0 0 185.7 200"
    },
    xmlSpace: "preserve",
    width: "3rem",
    height: "3rem",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0 { fill: #333d45; }\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.7,185.7c0,7.8-6.5,14.3-14.3,14.3H14.3C6.5,200,0,193.5,0,185.7V42.9C0,35,6.5,28.6,14.3,28.6h14.3V17.9 C28.6,8,36.6,0,46.4,0h7.1c9.8,0,17.9,8,17.9,17.9v10.7h42.9V17.9c0-9.8,8-17.9,17.9-17.9h7.1c9.8,0,17.9,8,17.9,17.9v10.7h14.3 c7.8,0,14.3,6.5,14.3,14.3V185.7z M46.4,103.6V71.4H14.3v32.1H46.4z M46.4,146.4v-35.7H14.3v35.7H46.4z M46.4,185.7v-32.1H14.3v32.1 H46.4z M57.1,17.9c0-1.9-1.7-3.6-3.6-3.6h-7.1c-1.9,0-3.6,1.7-3.6,3.6V50c0,1.9,1.7,3.6,3.6,3.6h7.1c1.9,0,3.6-1.7,3.6-3.6V17.9z  M89.3,103.6V71.4H53.6v32.1H89.3z M89.3,146.4v-35.7H53.6v35.7H89.3z M89.3,185.7v-32.1H53.6v32.1H89.3z M132.1,103.6V71.4H96.4 v32.1H132.1z M132.1,146.4v-35.7H96.4v35.7H132.1z M132.1,185.7v-32.1H96.4v32.1H132.1z M142.9,17.9c0-1.9-1.7-3.6-3.6-3.6h-7.1 c-1.9,0-3.6,1.7-3.6,3.6V50c0,1.9,1.7,3.6,3.6,3.6h7.1c1.9,0,3.6-1.7,3.6-3.6V17.9z M171.4,103.6V71.4h-32.1v32.1H171.4z  M171.4,146.4v-35.7h-32.1v35.7H171.4z M171.4,185.7v-32.1h-32.1v32.1H171.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraHoliday);
export default __webpack_public_path__ + "static/media/Extra_Holiday.85623871b8a05dcfc552fddf920c5247.svg";
export { ForwardRef as ReactComponent };